import { Box, styled } from '@mui/material';
import { fontSizes } from '../../theme';

export const DatePickerContainer = styled(Box)(({ theme }) => ({
  '.react-datepicker__input-container': {
    width: 'inherit',
  },

  '.react-datepicker-wrapper': {
    width: '100%',
  },
  '.react-datepicker': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    bottom: 1,
    '&-popper': {
      '&[data-placement^=bottom] .react-datepicker__triangle': {
        fill: theme.palette.background.default,
        color: theme.palette.background.default,
      },
      '&[data-placement^=top] .react-datepicker__triangle': {
        fill: theme.palette.background.paper,
        color: theme.palette.background.paper,
      },
      '.react-datepicker__triangle': {
        stroke: theme.palette.divider,
      },
      zIndex: 1000,
    },
    '&-year-header': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.default,
      fontSize: fontSizes.md,
    },
    '&__year-select': {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      border: '1px solid',
      borderRadius: '4px',
    },
    '&__header': {
      backgroundColor: theme.palette.background.default,
      borderBottom: `1px solid ${theme.palette.divider}`,
      borderTopLeftRadius: theme.shape.borderRadius,
    },
    '&__header:not(.react-datepicker__header--has-time-select)': {
      borderTopRightRadius: theme.shape.borderRadius,
    },
    '&__header--middle, &__header--bottom': {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    '&__current-month, &-time__header': {
      color: theme.palette.text.primary,
    },
    '&__day-name, &__day, &__time-name': {
      color: theme.palette.text.primary,
    },
    '&__day-name--disabled, &__day--disabled, &__time-name--disabled': {
      color: theme.palette.text.disabled,
    },
    '&__month': {
      '&-container': {
        fontSize: fontSizes.md,
      },
      '&-text': {
        margin: theme.spacing(0.5),
        padding: theme.spacing(0.25),
      },
    },
    // matches react-datepicker's own hover selector so it wins on specificity, not just source order
    '&__day:not([aria-disabled=true]):hover, &__month-text:not([aria-disabled=true]):hover, &__year-text:not([aria-disabled=true]):hover': {
      color: theme.palette.text.primary,
      backgroundColor: `${theme.palette.action.hover} !important`,
    },
    '&__day--selected, &__day--in-range, &__month-text--selected, &__year-text--selected': {
      color: `${theme.palette.primary.contrastText} !important`,
      backgroundColor: `${theme.palette.primary.main} !important`,
    },
    '&__day--keyboard-selected, &__month-text--keyboard-selected, &__year-text--keyboard-selected': {
      color: 'unset',
      backgroundColor: 'unset',
    },
    '&__time-container': {
      borderLeft: `1px solid ${theme.palette.divider}`,
    },
    '&__time-container .react-datepicker__time': {
      background: theme.palette.background.paper,
    },
    '&__time-list-item:not([aria-disabled=true]):hover': {
      backgroundColor: `${theme.palette.action.hover} !important`,
    },
    '&__time-list-item--selected, &__time-list-item--selected:hover': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: `${theme.palette.primary.contrastText} !important`,
    },
    '&__navigation': {
      marginTop: 4,
      '&-icon::before': {
        borderColor: theme.palette.text.primary,
      },
    },
  },
}));
